<template>
  <div v-if="!showAddUserComponent">
    <h2>Users of {{ organisation.name }}</h2>
    <button class="btn btn-primary mb-3" @click="showAddUserComponent = true">Add User</button>
    <table class="table table-sm table-responsive-sm table-striped">
      <thead>
      <tr>
        <th>Name</th>
        <th class="d-none d-sm-table-cell">Email</th>
        <th>Mobile</th>
        <th class="d-none d-md-table-cell">Actions</th>
      </tr>
      </thead>
      <tbody>
      <tr v-for="user in users" :key="user.id">
        <td>
          <button class="btn btn-primary btn-sm" @click="navigateToUser(user)">{{ user.last_name }} {{
              user.first_name
            }}
          </button>
        </td>
        <td class="d-none d-sm-table-cell">{{ user.email }}</td>
        <td>
          <button class="btn btn-sm btn-primary" @click="callNumber(user.mobile_number)">
            {{ user.mobile_number_international }}
          </button>
        </td>
        <td></td>
      </tr>
      </tbody>
    </table>
  </div>
  <div v-if="showAddUserComponent">
    <OrganisationUserAdd :organisation=organisation @close="handleclose"/>
  </div>
</template>

<script>
import OrganisationUserAdd from "@/components/OrganisationUserAdd.vue";
import {API_BASE_URL} from "@/config";

export default {
  components: {OrganisationUserAdd},
  data() {
    return {
      organisation: {},
      users: [],
      showAddUserComponent: false,
      newUser: {
        firstName: '',
        lastName: '',
        email: '',
        mobile: ''
      }
    }
  },
  created() {
    this.fetchUsers();
  },
  methods: {
    async fetchUsers() {
      try {
        const response = await fetch(
            `${API_BASE_URL}/organisations/${this.$route.params.slug}/users`,
            {
              method: 'GET',
              credentials: 'include',
            }
        );
        if (response.status === 403) {
          this.$router.push({name: 'forbidden'});
        } else if (response.status === 404) {
          this.$router.push({name: 'not-found'});
        } else {
          const data = await response.json();
          document.title = `${data.name} - Users Admin`;
          this.users = data.users;
          this.organisation = data;
          console.log(this.users);
        }
      } catch (error) {
        console.error('Error fetching users:', error);
      }
    },
    handleclose() {
      this.showAddUserComponent = false;
      this.fetchUsers();
    },
    callNumber(mobileNumber) {
      window.location.href = `tel:${mobileNumber}`;
    },
    navigateToUser(user) {
      this.$router.push({name: 'organisation-user', params: {username: user.username}});
    }
  }
}
</script>